import { RenderElementProps } from 'slate-react';
import { useTagNav } from 'app/state/contexts/TagContext';
import { isFootnote } from '../utils/footnote';

export const FootnoteElement = ({ attributes, children, element }: RenderElementProps) => {
  const { setSelectedFootnoteId } = useTagNav();
  const footnoteId = isFootnote(element) ? element.footnoteId : undefined;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedFootnoteId?.(footnoteId ?? null);
  };

  return (
    <span
      {...attributes}
      data-footnote-id={footnoteId}
      onClick={handleClick}
      style={{
        backgroundColor: 'rgba(237, 137, 54, 0.16)',
        borderLeft: '2px solid rgba(237, 137, 54, 0.7)',
        borderRight: '2px solid rgba(237, 137, 54, 0.7)',
        borderRadius: '10px',
        cursor: 'pointer',
      }}
      title="Fotnot"
    >
      {children}
    </span>
  );
};
